const data = [
	{
		Session: `2022 IEEE world conference on Applied Intelligence and  Computing (AIC 2022)`,
	},
	{
		Session: `Global conference on " Next generation Information  Communication Technology"`,
	},
];

export default data;
